/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Search_PlaceholderInputs */

const en_cmdk_search_placeholder = /** @type {(inputs: Cmdk_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by title, topic, or tag`)
};

const es_cmdk_search_placeholder = /** @type {(inputs: Cmdk_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca por título, tema o etiqueta`)
};

/**
* | output |
* | --- |
* | "Search by title, topic, or tag" |
*
* @param {Cmdk_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_search_placeholder = /** @type {((inputs?: Cmdk_Search_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Search_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_search_placeholder(inputs)
	return en_cmdk_search_placeholder(inputs)
});